
import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

interface Country {
  code: string;
  name: string;
}

export const useCountriesForAnalytics = () => {
  const [countries, setCountries] = useState<Country[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchCountries = async () => {
      setIsLoading(true);
      try {
        const { data, error } = await supabase
          .from('countries')
          .select('code, name')
          .eq('active', true)
          .order('name');

        if (error) throw error;
        setCountries(data || []);
      } catch (error) {
        console.error('Error fetching countries for analytics:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchCountries();
  }, []);

  return { countries, isLoading };
};
